import React from "react";
import styled from "styled-components";
import { color } from "../templates/ui";
import ErrorLabel from "./ErrorLabel";
import _ from "lodash";

const StyledSelectItem = styled.div`
  position: relative;
`;

const SelectWrapper = styled.div`
  position: relative;

  &:after {
    content: "";
    display: block;
    background-image: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA1Ny4yIDMyLjIiIGVuYWJsZS1iYWNrZ3JvdW5kPSJuZXcgMCAwIDU3LjIgMzIuMiI+ICA8cGF0aCBkPSJNMCAzLjZDMCAyLjcuNCAxLjcgMS4xIDEgMi41LS40IDQuOC0uNCA2LjMgMWwyMi4zIDIyLjNMNTAuOSAxLjFjMS40LTEuNCAzLjctMS40IDUuMiAwIDEuNCAxLjQgMS40IDMuNyAwIDUuMmwtMjUgMjQuOWMtMS40IDEuNC0zLjcgMS40LTUuMiAwTDEuMSA2LjNDLjQgNS42IDAgNC42IDAgMy42eiIgZmlsbD0iIzAwMjg1NiIvPjwvc3ZnPg==);
    background-repeat: no-repeat;
    width: 14px;
    height: 8px;
    position: absolute;
    top: 50%;
    right: 10px;
    transform: translateY(-50%);
    pointer-events: none;
  }
`;

const StyledSelect = styled.select`
  transition: border-color 0.2s ease-in-out;
  position: relative;
  border: 1px solid ${color.gray.base};
  border-radius: 7px;
  width: 100%;
  background-color: ${color.body.base};
  height: 48px;
  padding-left: 14px;
  padding-right: 34px;
  color: ${props => props.theme.tertiary};
  font-size: 14px;
  font-weight: 400;
  appearance: none;
  min-width: 80px;

  &:focus {
    outline: none;
  }

  &:disabled {
    background-color: #efefef;
    opacity: 0.8;
  }

  option {
    color: #bbbbbb;
    font-weight: 400;
  }
`;

const SelectItem = ({
  value = "",
  placeholder,
  options = [],
  labelText,
  className,
  onChange,
  disabled,
  error,
}) => (
  <StyledSelectItem className={className}>
    {labelText && <label>{labelText}</label>}
    <SelectWrapper>
      <StyledSelect
        value={value}
        placeholder={placeholder}
        onChange={onChange}
        disabled={disabled}
      >
        <option value="">{placeholder}</option>
        {options.map(option => (
          <option key={option.id} value={option.id}>
            {option.name}
          </option>
        ))}
      </StyledSelect>
    </SelectWrapper>
    {!!error && <ErrorLabel>{_.capitalize(error)}</ErrorLabel>}
  </StyledSelectItem>
);

export default SelectItem;
